export const CallCorrectnessConstants = {
  CORRECT: "CORRECT",
  INCORRECT: "INCORRECT",
  ACCEPTABLE: "ACCEPTABLE",
  ADJUSTED: "ADJUSTED",
  CATCHER_INFLUENCE: "CATCHER_INFLUENCE",
  LOW_BUFFER: "LOW_BUFFER",
  LOW_CATCH: "LOW_CATCH",
  HIGH_BUFFER: "HIGH_BUFFER",
  UNKNOWN: "UNKNOWN"
};
